/* Quick order via WhatsApp: rebuild the wa.me link from the variant and quantity chosen right now. */
(function () {
  if (window.adenzoWhatsappOrder) return;

  function buildMessage(template, data) {
    var message = template;
    if (data.variant) {
      message = message.split('{variant}').join(data.variant);
    } else {
      message = message.split(' – {variant}').join('').split(' - {variant}').join('').split('{variant}').join('');
    }
    return message
      .split('{product}').join(data.product)
      .split('{qty}').join(String(data.qty))
      .split('{price}').join(data.price)
      .split('{link}').join(data.link);
  }

  function hrefFor(button) {
    var root = button.closest('.adenzo-wa-order');
    var variants = JSON.parse(root.querySelector('[data-adenzo-wa-variants]').textContent);
    var input = document.querySelector('#' + button.dataset.form + ' input[name="id"]');
    var variant = (input && variants[input.value]) || variants[Object.keys(variants)[0]];
    var qtyInput = document.getElementById('Quantity-' + button.dataset.section);
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var message = buildMessage(button.dataset.template, {
      product: button.dataset.product,
      variant: variant.default ? '' : variant.title,
      qty: qty,
      price: variant.price,
      link: button.dataset.origin + variant.url,
    });
    return 'https://wa.me/' + button.dataset.phone + '?text=' + encodeURIComponent(message);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-adenzo-wa-order]');
    if (!button) return;
    try {
      button.href = hrefFor(button);
    } catch (error) {
      // Keep the server-rendered link for the initial variant.
    }
  });

  window.adenzoWhatsappOrder = { buildMessage: buildMessage, hrefFor: hrefFor };
})();
